import type { SVGProps } from 'react';

// viewBox padded beyond the 20-grid artwork so the painted ink spans exactly
// the same vertical band as lucide Calendar/Settings — verified by the
// measured-bounds table in the Icons/HeaderNavIcons story.
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0.1725 0.1567 19.6611 19.6611"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6665 18.801H5.3332C3.81654 18.801 2.43321 17.6343 2.18321 16.1343L1.07487 9.50102C0.89987 8.46769 1.39987 7.14269 2.22487 6.48436L7.99988 1.85932C9.11655 0.95932 10.8749 0.967662 11.9999 1.86766L17.7749 6.48436C18.5915 7.14269 19.0915 8.46769 18.9249 9.50102L17.8165 16.1343C17.5665 17.6093 16.1582 18.801 14.6665 18.801ZM9.99155 2.45101C9.54988 2.45101 9.1082 2.58431 8.7832 2.84265L3.00821 7.46769C2.53321 7.85102 2.20821 8.70098 2.30821 9.30098L3.41655 15.9343C3.56655 16.8093 4.44154 17.551 5.3332 17.551H14.6665C15.5582 17.551 16.4332 16.8093 16.5832 15.926L17.6915 9.29269C17.7915 8.69269 17.4582 7.83435 16.9915 7.45935L11.2165 2.84265C10.8832 2.58431 10.4415 2.45101 9.99155 2.45101Z"
      fill="currentColor"
    />
    <path
      d="M9.99984 13.5417C8.50817 13.5417 7.2915 12.325 7.2915 10.8333C7.2915 9.34167 8.50817 8.125 9.99984 8.125C11.4915 8.125 12.7082 9.34167 12.7082 10.8333C12.7082 12.325 11.4915 13.5417 9.99984 13.5417ZM9.99984 9.375C9.19984 9.375 8.5415 10.0333 8.5415 10.8333C8.5415 11.6333 9.19984 12.2917 9.99984 12.2917C10.7998 12.2917 11.4582 11.6333 11.4582 10.8333C11.4582 10.0333 10.7998 9.375 9.99984 9.375Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgHome;
